//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Config from "../Config/config";
export default {
  name: "enter",
  data() {
    return {
      title: 1,
      value_search: "",
      search_id: "",
      results: [],
      name: "",
      password: null,
      resolve_password: null,
      tel: null,
      sex: [],
      data_sex: [
        [
          { name: "男", value: "0" },
          { name: "女", value: "1" }
        ]
      ],
      store: [],
      data_store: [[]],
      car_no: [],
      data_car: [
        [
          "粤",
          "京",
          "津",
          "黑",
          "吉",
          "辽",
          "冀",
          "豫",
          "鲁",
          "晋",
          "陕",
          "蒙",
          "宁",
          "陇",
          "甘",
          "新",
          "青",
          "藏",
          "鄂",
          "皖",
          "苏",
          "沪",
          "浙",
          "闽",
          "湘",
          "赣",
          "川",
          "渝",
          "贵",
          "云",
          "桂",
          "琼",
          "港",
          "澳",
          "台"
        ]
      ],
      car_number: "",
      car_name: "",
      car_tel: null
    };
  },
  beforeRouteEnter (to, from,next){
      let is_market = sessionStorage.getItem('is')
      let market = sessionStorage.getItem('market')
      
      let x = {
        id:'',
        hid:'',
      }
      if(market){
        let obj = JSON.parse(market)
        x.id = obj.id 
        x.hid = obj.hid
      }
      console.log(is_market);
      console.log(x.hid);
      if(market && x.hid !== is_market){
        let obj = JSON.parse(market)
        let id = obj.id
        let hid = obj.hid
        let is = hid
        sessionStorage.setItem('is',is)
        window.location.href = `https://api.hfbsoftware.com/member/couponx/marketing?id=${id}&hid=${hid}`
      }else{
        next()
        sessionStorage.removeItem('is')
      }
  },
  methods: {
    search: function() {
      this.results = [];
      this.$HTTP
        .HttpPost("/Member/Login/getCustomerSearchSelect", {
          search: this.value_search,
          hid: sessionStorage.hid
        })
        .then(data => {
          if (data.data.data.length === 0) {
            return this.$vux.toast.show({
              text: "未搜索到车牌,请转到注册!",
              type: "text",
              width: "80%",
              isShowMask: true
            });
          }
          this.results = data.data.data.map((item, index) => {
            return {
              title: item.plate_id + item.license_plate_number,
              id: item.id
            };
          });
        });
    },
    onResultClick: function(value) {
      this.value_search = value.title;
      this.search_id = value.id;
    },
    enter: function() {
      const bindInfo =
        sessionStorage.getItem("bindInfo") &&
        JSON.parse(sessionStorage.getItem("bindInfo"));
      this.tel = this.tel.replace(/\s+/g, "");
      this.$HTTP
        .HttpPost("/Member/Login/register", {
          name: this.name,
          password: this.password,
          repassword: this.resolve_password,
          tel: this.tel,
          // sex: this.sex.join(""),
          sid: this.store.join(""),
          plate_id: this.car_no.join(""),
          license_plate_number: this.car_number,
          openid: sessionStorage.openid,
          hid: sessionStorage.hid,
          ...bindInfo
        })
        .then(data => {
          if (data.data.code === 200) {
            sessionStorage.setItem('token', data.data.data.token)
            console.log(111111)
            let market = sessionStorage.getItem('market')
            let obj = JSON.parse(market)
            if(market){
              this.$router.push({
                path:'/marketing',
                query:obj,
              })
            }
            this.$router.go(-2);
            // window.location.href = "http://api.hfbsoftware.com/member/login/login?hid="+sessionStorage.hid;
          }
          this.$vux.toast.show({
            text: data.data.msg,
            type: "text",
            width: "80%",
            isShowMask: true
          });
        });
    },
    binding: function() {
      const bindInfo =
        sessionStorage.getItem("bindInfo") &&
        JSON.parse(sessionStorage.getItem("bindInfo"));
      this.car_tel = this.car_tel.replace(/\s+/g, "");
      this.$HTTP
        .HttpPost("/Member/Login/accountBind", {
          chepai: this.car_no + this.car_number,
          name: this.car_name,
          tel: this.car_tel,
          openid: sessionStorage.openid,
          hid: sessionStorage.hid,
          ...bindInfo
        })
        .then(data => {
          if (data.data.code === 200) {
            sessionStorage.setItem('token', data.data.data.token)
            console.log(111111)
            let market = sessionStorage.getItem('market')
            let obj = JSON.parse(market)
            if(market){
              this.$router.push({
                path:'/marketing',
                query:obj,
              })
            }
            this.$router.go(-2);
            // window.location.href = "http://api.hfbsoftware.com/member/login/login?hid="+sessionStorage.hid;
          }
          this.$vux.toast.show({
            text: data.data.msg,
            type: "text",
            width: "80%",
            isShowMask: true
          });
        });
    }
  },
  created() {
    sessionStorage.openid = this.$router.currentRoute.query.openid;
    if (
      this.$router.currentRoute.query.openid === undefined &&
      Config.mode === "pro"
    ) {
      // window.location.href = "http://api.hfbsoftware.com/member/login/login?hid="+sessionStorage.hid+"&coupons_id="+this.$router.currentRoute.query.id;
    }
  },
  mounted() {
    this.$HTTP
      .HttpPost("/member/login/getStoreSelect", { hid: sessionStorage.hid })
      .then(data => {
        this.data_store[0] = data.data.data.map((item, index) => {
          return { name: item.store_name, value: item.id.toString() };
        });
      });
  }
};



// WEBPACK FOOTER //
// ./src/components/enter.vue